// extracted by mini-css-extract-plugin
module.exports = {"label":"_35875ce240--label--aa8c7","label-desktop":"_35875ce240--label-desktop--BhoM2"};